import {BasketCustomer, BasketItem} from '../../../shared/classes/carrito';
import {Customer} from '../../../shared/models/customer';
import {UserService} from '../../../shared/services/user.service';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CartItem} from '../../../shared/classes/cart-item';
import {CartService, SecureCartItem} from '../../../shared/services/cart.service';
import {OrderService} from '../../../shared/services/order.service';
import {Observable, of, Subscription} from 'rxjs';
import {BasketService} from "../../../shared/services/basket.service";
import {toLong} from "../../../shared/utils/utils";
import {Router} from "@angular/router";
import {CustomSnackbarService} from "../../../shared/services/custom.snackbar.service";
import {SnackbarTypeError} from "../../../shared/msg-snackbar/msg-snackbar.component";
import {Branch, BranchFilter} from "../../../shared/models/branch";
import {BranchService} from "../../../shared/services/branch.service";
import { map } from 'rxjs/operators';
import { CustomerService } from 'src/app/shared/services/customer.service';
import {ArticleService} from "../../../shared/services/article.service";
import {Article} from "../../../shared/models/article";

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss'],
    providers: [UserService, BasketService, CustomSnackbarService, BranchService, ArticleService],
    standalone: false
})
export class CheckoutComponent implements OnInit, OnDestroy {

    // form group
    public checkoutForm: FormGroup;
    public cartItems: Observable<CartItem[]> = of([]);
    public checkOutItems: CartItem[] = [];
    public amount: number;
    public customer: Customer;
    loading: boolean;
    branchList: Branch[] = [];
    shippingCost: number = 5000;
    // TODO: reactivar mayorista/minorista — cambiar a of(false) y descomentar la asignación en ngOnInit
    public isWholesaler$: Observable<boolean> = of(true);
    private cartSubscription: Subscription;

    // Form Validator
    constructor(private fb: FormBuilder, private cartService: CartService,
                 private orderService: OrderService,
                public userService: UserService, private basketService: BasketService,
                private branchService: BranchService, private customSnackbarService: CustomSnackbarService,
                private router: Router, private customerService: CustomerService,
                private articleService: ArticleService) {
        this.customer = this.userService.getIdentity();
        this.checkoutForm = this.fb.group({
            firstname: [(this.customer) ? this.customer.name : '', [Validators.required]],
            lastname: [(this.customer) ? this.customer.lastName : ''],
            phone: [(this.customer) ? this.customer.cellphone : '', [Validators.required]],
            email: [(this.customer) ? this.customer.email : ''],
            address: [(this.customer) ? this.customer.address : ''],
            town: [(this.customer) ? this.customer.state : ''],
            state: [(this.customer) ? this.customer.district : ''],
            postalcode: [(this.customer) ? this.customer.zipCode : ''],
            branch: ['', [Validators.required]],
            // TODO: reactivar modalidad de envío — cambiar a ['', [Validators.required]]
            deliveryOption: ['localPickup'],
        });
    }

    ngOnInit() {
        this.loading = true;
        this.getTotal().subscribe(amount => this.amount = amount);
        this.checkoutForm.controls['firstname'].markAsTouched();
        this.checkoutForm.controls['phone'].markAsTouched();
        this.checkoutForm.controls['branch'].markAsTouched();
        this.loadBranches();
        // TODO: reactivar mayorista/minorista — descomentar esto y cambiar isWholesaler$ inicial a of(false)
        // const customerId = this.getCustomer()?.id || null;
        // if (customerId) {
        //     this.isWholesaler$ = this.customerService.isWholesaler(customerId);
        // }

        // Subscribe to cart changes to load products from backend
        this.cartSubscription = this.cartService.cartItems.subscribe((secureItems) => {
            this.loadCartItemsFromSecureItems(secureItems);
        });
    }

    ngOnDestroy() {
        if (this.cartSubscription) {
            this.cartSubscription.unsubscribe();
        }
    }

    private loadCartItemsFromSecureItems(secureItems: SecureCartItem[]) {
        this.checkOutItems = [];

        if (secureItems && secureItems.length > 0) {
            // Extract SKUs from cart items
            const skus = secureItems.map(item => item.sku);

            // Load products from backend using SKUs
            this.articleService.getArticlesBySku(skus).subscribe(
                (products: Article[]) => {

                    // Map products to cart items
                    this.checkOutItems = secureItems
                        .map(secureItem => {
                            const product = products.find(p => p.sku === secureItem.sku);
                            if (product) {
                                return {
                                    product: product,
                                    quantity: secureItem.quantity
                                } as CartItem;
                            } else {
                                console.error('❌ [Checkout] Producto NO encontrado para SKU:', secureItem.sku);
                            }
                            return null;
                        })
                        .filter(item => item !== null); // Remove items where product wasn't found

                },
                error => {
                    console.error('❌ [Checkout] Error loading cart products:', error);
                    this.checkOutItems = [];
                }
            );
        } else {
            // Empty cart
            this.checkOutItems = [];
        }
    }

    loadBranches = () => {
        const branchFilter = new BranchFilter();
        branchFilter.page = 0;
        this.branchService.getList(branchFilter).subscribe(
            res => {
                const body = JSON.parse(res.body);
                this.branchList = body.rows;
                if (this.branchList.length == 1) {
                    this.checkoutForm.controls['branch'].setValue(this.branchList[0].id);
                }
            }
        )
        this.loading = !this.loading;
    }

    getPrice(item) {
        return this.cartService.getPrice(item);
    }

    // Get sub Total
    public getSubTotal(): Observable<number> {
        return this.cartService.getTotalAmount();
    }
    public getTotal(): Observable<number> {
        return this.cartService.getTotalAmount().pipe(
          map(total => {
            const deliveryOption = this.checkoutForm.controls["deliveryOption"].value;
            const showShipping = deliveryOption === 'homeDelivery' || deliveryOption === 'branchDelivery';
            return showShipping ? total + this.shippingCost : total;
          })
        );
    }

    getFormControlValue(key) {
        return this.checkoutForm.controls[key].value;
    }

    getCustomer() {
        let customer: Customer = this.userService.getIdentity();
        if (!customer) {
            let customer = new Customer()
            return customer;
        }
        return customer;
    }


    getBasketCustomer() {
        const basketCustomer: BasketCustomer = new BasketCustomer();
        basketCustomer.name = this.getFormControlValue('firstname');
        basketCustomer.lastName = this.getFormControlValue('lastname');
        basketCustomer.cellphone = this.getFormControlValue('phone');
        basketCustomer.email = this.getFormControlValue('email');
        basketCustomer.address = this.getFormControlValue('address');
        basketCustomer.state = this.getFormControlValue('state');
        basketCustomer.zipCode = this.getFormControlValue('postalcode');
        return basketCustomer;
    }

    armarListadoProductos() {
        let basketItems: BasketItem[] = [];
        this.checkOutItems.forEach(carItem => {
            let item: BasketItem = new BasketItem();
            item.item = carItem.product;
            item.quantity = carItem.quantity;
            item.unitPrice = Math.trunc(toLong(this.getPrice(carItem)));
            let itemToAdd = JSON.parse(JSON.stringify(item));
            basketItems.push(itemToAdd);
        });
        return basketItems;
    }

    getBranch = () => {
        const selectedId = Number(this.getFormControlValue('branch'));
        const branchFilter = this.branchList.filter(branch => branch.id === selectedId);
        return branchFilter[0];
    }

    stripeCheckout() {
        this.loading = true;
        const carrito = {
            listadoArticulos: this.armarListadoProductos(),
            customerDelivery: this.getBasketCustomer(),
            customer: this.getCustomer(),
            branch: this.getBranch(),
            deliveryAmount: this.checkoutForm.get('deliveryOption')!.value == "homeDelivery" ? this.shippingCost : 0
        };
        let total = 0;
        this.cartService.getTotalAmount().subscribe(t => total = t);
        this.basketService.realizarCompra(carrito).subscribe(
            res => {
                const order = JSON.parse(res.body);
                this.cartService.vaciarCarrito();
                this.loading = false;
                this.router.navigate(['/home/checkout/success', order.id]);
            },
            error => {
                this.customSnackbarService.open('Ha surgido un error', SnackbarTypeError.ERROR);
                console.error(error);
            }
        )
    }
    showShippingCost(): boolean {
        const option = this.checkoutForm.controls["deliveryOption"].value;
        return option === 'homeDelivery' || option === 'branchDelivery';
    }


}